import { useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { useTenantStore } from "../../stores/tenant";
import { Toaster } from "../ui/toaster";

export function Shell({ children }: { children: ReactNode }) {
  const loadAvailable = useTenantStore((s) => s.loadAvailable);
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    loadAvailable().catch(() => {});
  }, [loadAvailable]);

  // Ferme le drawer mobile à chaque navigation.
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  // Bloque le scroll de fond quand le drawer est ouvert (mobile).
  useEffect(() => {
    document.body.style.overflow = navOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [navOpen]);

  return (
    <div className={`shell${navOpen ? " is-nav-open" : ""}`}>
      <aside className="shell__sidebar" id="app-sidebar">
        <Sidebar />
      </aside>
      <div className="shell__backdrop" onClick={() => setNavOpen(false)} aria-hidden="true" />
      <header className="shell__topbar">
        <Topbar onMenu={() => setNavOpen((v) => !v)} navOpen={navOpen} />
      </header>
      <main className="shell__content">{children}</main>
      <Toaster />
    </div>
  );
}
